export const getActive = (block, context) => {
  const crossConfig = context?.crossData?.[block.service_block_id]?.[block.id];
  return (![null, undefined].includes(crossConfig?.active) ? crossConfig.active : block.active);
}